// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  eSignCommonApiUrl: "https://cmnapi.ascendion.com/",
  //eSignApiUrl: "https://localhost:44374",
  //redirectUrl: "https://localhost:4200",
  FileFromAzureBlobUrl: "https://cmnapi.ascendion.com/DownloadFileFromAzureBlob?FileName=",
  eSignApiUrl: "https://esignvendorapi.ascendion.com",
  redirectUrl: "http://esignvendor.ascendion.com",
  // redirectUrl: "https://devesignvendor.ascendion.com",   
  devEsignConsultantApiUrl: "https://esignconsultantapi.ascendion.com",
  // //redirectUrl: "https://devconsultantesign.collabera.com/",
  // redirectUrl: "https://devconsultantesign.collabera.com/",
  // scopeUri: ['api://f682e4e9-6f4d-4153-a801-513c82a361b5/bgvapiaccess'],  
  // tenantId: 'f002d715-9cd8-4634-8055-187d4ca6d2c4',  
  // uiClienId: '313c7b2d-12bd-406d-bb84-920c438a4ffe',
  maxFileSize: 20
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
